import "ngstorage";

import {WALKTHROUGH_STATES, TRIGGER_NEXT_EVENT_NAME, UPDATE_WORKFLOW_EVENT_NAME} from "../../variables";

class ArrivalinstructionsController {
  constructor($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
    this.name = "arrivalinstructions";
    this.walkthroughState = WALKTHROUGH_STATES.ARRIVAL_INSTRUCTIONS;

    this.$localStorage = $localStorage;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.$tracking = TrackingService;
    this.$events = events;

    this.API_FIELDS = "arrivalInstructions,onsiteManagerName,onsiteManagerNumber";

    this.PostAJobSaveAndExitListener = this.$rootScope.$on("PostAJobSaveAndExit", ($event, params) => {
      this.saveArrivalInstructions();
    });

    this.$scope.$on("$destroy", this.PostAJobSaveAndExitListener);

    console.log("Initialize Shift", localStorage.savingInstructions);
  }

  $onInit() {
    this.syncWithApi();
    this.blurElement();
  }

  blurElement() {
    this.$timeout(() => {
      $(document.activeElement).blur();
      this.focusEle();
    }, 300);
  }

  focusEle() {
    this.$timeout(() => {
      const el = document.getElementById("job-post-job-arrival");
      el.focus();
      //el.select();
    }, 300);
  }

  syncWithApi() {
    this.setLoader();
    this.$events.getEventByIdWithFields(this.event.id, this.API_FIELDS).then((data) => {
      if (!(localStorage.savingInstructions && JSON.parse(localStorage.savingInstructions))) {
        console.log("Updating Shift Description");
        this.event.arrival_instructions = data.data.arrivalInstructions;
        this.event.onsite_manager_name = data.data.onsiteManagerName;
        this.event.onsite_manager_number = data.data.onsiteManagerNumber;
      } else {
        console.warn("Skipping update to Shift Description");
      }
      this.unSetLoader();
    });
  }

  setLoader() {
    this.$timeout(() => {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.$timeout(() => {
      $("html").removeClass("wait");
    });
  }

  saveArrivalInstructions() {
    localStorage.savingInstructions = true;
    console.log("starting saving arrival instruct");
    this.setLoader();
    this.$events
      .saveEventArrivalInstructions(this.event.id, this.event.arrival_instructions, this.event.onsite_manager_name, this.event.onsite_manager_number)
      .then((data) => {
        this.$tracking.reportPostAJobSubmitStep("onsite info");
        console.log("Saved onsite info to event:", data);
        localStorage.savingInstructions = false;
        console.log("ending saving arrival instruct");
        this.unSetLoader();
        //this.$rootScope.$emit("ArrivalInstructionsSaved",{});
        this.$rootScope.$emit(TRIGGER_NEXT_EVENT_NAME, {
          walkthroughState: this.walkthroughState,
        });
        /*
            this.$timeout(() => {
                this.syncWithApi();
            }, 500);
             */
      });
  }

  validate() {
    this.event.onsite_manager_number = this.event.onsite_manager_number
      ? this.event.onsite_manager_number.replace(/\D/g, "")
      : this.event.onsite_manager_number;
    this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
  }

  goNext() {
    this.saveArrivalInstructions();
  }
}

ArrivalinstructionsController.$inject = [
  "$localStorage",
  "$rootScope",
  "$scope",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "security",
  "$timeout",
  "tracking",
  "events",
];

export default ArrivalinstructionsController;



// WEBPACK FOOTER //
// ./client/app/scenes/postashiftwalkthrough/scenes/arrivalinstructions/arrivalinstructions.controller.js